import { object } from "prop-types";
import React, { useEffect, useState } from "react";
import BigSectionHeroImage from "../../../../components/story-templates/big-section-hero-image";
import { SeriesPageTabComponent } from "../SeriesPageTabComponent";
import "../../../../components/pages/section.m.css";
import "../OneBigThreeSmallSectionLayout/one-big-three-small-section-layout.m.css";
import "./series-page.m.css";
import { AccessType } from "@quintype/components";
import { useSelector } from "react-redux";
import get from "lodash/get";

const SeriesPageLayout = ({ data }) => {
  // AT data
  const [isATGlobal, setIsATGlobal] = useState(false);
  const member = useSelector((state) => get(state, ["member"], null));
  const email = get(member, ["email"], "");
  const phone = get(member, ["metadata", "phone-number"], "");
  const { key, accessTypeBkIntegrationId, ATBaseUrl } = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "accesstypeConfig"], {})
  );
  // AT data

  return (
    <div styleName="container" style={{padding: "0"}}>
      <div styleName="main-contents">
        <React.Fragment>
          <div styleName="wrapper black" className="one-big-three-small-section-layout-wrapper">
            <div styleName="">
              <div styleName="container-wrapper">
                  <div styleName="big-img">
                    <AccessType
                      enableAccesstype={true}
                      accessTypeKey={key}
                      email={email}
                      phone={phone}
                      prodHost={ATBaseUrl}
                      stagingHost={ATBaseUrl}
                      accessTypeBkIntegrationId={accessTypeBkIntegrationId}
                      onATGlobalSet={() => setIsATGlobal(true)}
                    >
                      {({ initAccessType, getSubscriptionForUser, cancelSubscription }) =>
                        <BigSectionHeroImage
                          data={data}
                          initAccessType={initAccessType}
                          getSubscriptionForUser={getSubscriptionForUser}
                          cancelSubscription={cancelSubscription}
                          isATGlobal={isATGlobal}
                          member={member}
                        />
                      }
                    </AccessType>

                    <SeriesPageTabComponent
                      data={data}
                    />
                  </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      </div>
    </div>
  );
}

SeriesPageLayout.propTypes = {
  data: object
};

export { SeriesPageLayout };
